import {useEffect, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {matchRoutes, useLocation} from 'react-router-dom';
import {useFrameService, useFrameKey} from '@ey/canvascoreservices';
import {
	useAresUrlParameters,
	useIsCompareResponsesView,
	useIsDrawerMode,
	useIsTrackChangesView,
	useSelectedStEntityId
} from '../../../util/Ares/customHooks';
import {frameSubEvent} from '../../../util/uiconstants';
import {useQuery} from '../../../util/customHooks';
import {isNullOrUndefined, labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import {getSectionById, getTaskDocumentByDocumentId} from '../../../selectors/Ares/selectors';

export default function ReactiveTabRenamer({children}) {
	useTabRenamer();

	return children;
}

const useTabRenamer = () => {
	const frameService = useFrameService();
	const query = useQuery();
	const isDrawerMode = useIsDrawerMode();
	const isTrackChangesView = useIsTrackChangesView();
	const isCompareResponsesView = useIsCompareResponsesView();
	const {frameKey} = useFrameKey();
	const {documentId, sectionId, isBodyDetailView} = useAresUrlParameters();
	const section = useSelector((state) => getSectionById(state, sectionId));
	const [stEntityId] = useSelectedStEntityId();
	const document = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));
	const location = useLocation();

	const isMainActivites = useMemo(() => {
		const match = matchRoutes([{path: '/guidedworkflowv2'}], location.pathname);
		if (Array.isArray(match) && match.length > 0) {
			return true;
		}
		return false;
	}, [location.pathname]);

	useEffect(() => {
		let name;
		let prefix;

		if (isTrackChangesView || isCompareResponsesView) {
			prefix = isTrackChangesView ? labels.trackChanges : labels.compareResponsesLabel;
			const sectionName = section?.name || null;
			name = `${prefix}: ` + Utility.getHtmlTextElement(sectionName);
		} else if (isMainActivites) {
			name = labels.mainActivities;
		} else {
			name = document?.documentName || null;
		}

		if (isDrawerMode && query.target && !isBodyDetailView && !isNullOrUndefined(name) && frameKey) {
			setTimeout(() => {
				/*we need to wait for the url to update before setting deepLinkSrc*/
				const args = {
					frameKey,
					name,
					updateFrameTitle: true,
					deepLinkSrc: window.location.href,
					subEvent: frameSubEvent.UPDATE_FRAME_TITLE
				};

				frameService.sendMessageToParent(args);
			}, 500);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		document?.documentName,
		section?.name,
		isDrawerMode,
		isTrackChangesView,
		isCompareResponsesView,
		isMainActivites,
		frameKey,
		query.target,
		isBodyDetailView,
		stEntityId
	]);
};
